// stores/userStore.js
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
    state: () => ({
        user: window.INITIAL_STATE.user || null,
    }),
    actions: {
        setUser(user) {
            this.user = user
        },
        clearUser() {
            this.user = null
        },
        updateUser(data) {
            if (this.user) {
                Object.assign(this.user, data);
            }
        },

        /** Слухач сповіщень про дублюючу сесію */
        listenForDuplicateSessionDetected(callback) {
            window.Echo.private(`user.${this.user.id}`)
                .listen('.DuplicateSessionDetected', (e) => {
                    callback(e);
                });
        }
    },
    getters: {
        isAuthenticated: (state) => state.user !== null,
    }
})
